module.exports = __webpack_public_path__ + "media/logos/expo_cuu_black-f95048e4.png";